export default __webpack_public_path__ + "static/media/Geico 10.16ea832a.jpg";